import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import type { Answer } from 'modules/surveys/components/Analytics/ScoreResults/hooks'
import EmployeeLabel from 'modules/surveys/components/Form/CommonEmployeeLabel'
import type { Question } from 'modules/surveys/store/models/AnalyticResult'

interface Props {
  question: Question
  answers: Answer[]
  onClose: () => void
}

const AnswersModal = ({ question, answers, onClose }: Props) => {
  const description = i18n.tView('surveys.analytics.charts.modal', {
    value: <strong>{answers[0]?.value}</strong>,
  })

  return (
    <Modal
      onClose={onClose}
      title={question.label}
      description={description}
      illustration="surveys"
    >
      <Box
        background="grey400"
        borderRadius={{
          all: 'abs008',
        }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        gap="s1"
        overflowX="hidden"
        overflowY="hidden"
      >
        {answers.map((answer) => (
          <Box paddingX="s24" paddingY="s16" background="grey000White" key={answer.respondentId}>
            <EmployeeLabel key={answer.respondentId} user={users.get(answer.respondentId)} />
          </Box>
        ))}
      </Box>
    </Modal>
  )
}

export default observer(AnswersModal)
